import { CustomSourceComponent } from './components/custom-source/custom-source.component';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { IhmLoadingIndicatorModule } from '@ihm-software/ihm-ui-common-angular-10';

import { SharedModule } from '../shared/shared.module';
import { CustomSourceDialogComponent } from './components/custom-source-dialog/custom-source-dialog.component';
import {
  StationDeleteDialogComponent,
  StationSettingsComponent,
} from './components/settings-station/station-settings.component';
import { SidebarStationService } from '../sidebar-station/sidebar-station.service';
import { StationManagementComponent } from './station-management.component';
import { StationManagementRoutingModule } from './station-management.routing';


@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    StationManagementRoutingModule,
    SharedModule,
    IhmLoadingIndicatorModule.forRoot(true)
  ],
  declarations: [
    StationManagementComponent,
    StationDeleteDialogComponent,
    StationSettingsComponent,
    CustomSourceDialogComponent,
    CustomSourceComponent],
  providers: [SidebarStationService],
  entryComponents: [StationDeleteDialogComponent]
})
export class StationManagementModule { }
